/** Discriminator for a structured payment-term rule stored as JSON in Template.value. */
export enum PaymentTermTypeEnum {
  standard = 'standard',
  downPayment = 'downPayment',
  card = 'card',
}

/** Event a down-payment balance becomes due on. Today only the ship event is modeled. */
export enum PaymentTermDueEventEnum {
  shipping = 'shipping',
}
